import _ from "lodash";
import {decorate, observable} from "mobx";
import {toast} from "react-toastify";
import {DEFAULT_UNSET_WATERMARK} from "../httpClients/ClippyApi";

const NO_WATERMARKS_MESSAGE = "Failed to fetch watermarks; watermarking disabled.";

class WatermarkStore {

  constructor(clippyApi) {
    this.clippyApi = clippyApi;
    this.watermarks = [DEFAULT_UNSET_WATERMARK]
  }

  initialize() {
    this.getAvailableWatermarks();
  }

  getAvailableWatermarks() {
    this.clippyApi.getAvailableWatermarks()
      .then(result => {

        if (result.length === 0) {
          toast.error(NO_WATERMARKS_MESSAGE)
          return;
        }

        // Watermarks will be sorted with `None` at the top, followed by files in alpha-order (Asc)
        this.watermarks = [DEFAULT_UNSET_WATERMARK,
          ..._.map(result, (watermark) => {
            return watermark.filename
          }).sort()
        ];
      })
      .catch(() => {
        toast.error(NO_WATERMARKS_MESSAGE)
      });
  }
}

decorate(WatermarkStore, {
  availableWatermarks: observable
});

export default WatermarkStore;


// WEBPACK FOOTER //
// ./src/stores/WatermarkStore.js